import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const Container = styled.div`
  background: ${(p) => p.theme.surface};
  padding: 60px 24px;
  text-align: center;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: background 320ms cubic-bezier(0.4, 0, 0.2, 1);
`;

const Icon = styled.div`
  font-size: 48px;
  color: ${(p) => p.theme.muted};
  margin-bottom: 16px;
  opacity: 0.5;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${(p) => p.theme.text};
  margin-bottom: 8px;
`;

const Sub = styled.p`
  font-size: 14px;
  color: ${(p) => p.theme.muted};
`;

const PlaceholderPage: React.FC = () => {
  const location = useLocation();
  const name = location.pathname.replace('/', '').replace(/-/g, ' ');

  return (
    <Container>
      <Icon>
        <i className="fas fa-hard-hat"></i>
      </Icon>
      <Title style={{ textTransform: 'capitalize' }}>{name || 'Page'}</Title>
      <Sub>This section is coming soon.</Sub>
    </Container>
  );
};

export default PlaceholderPage;
